import { LayoutSDK } from '@notes/sticky-notes-layout'
import { AuthType } from '@notes/webintegrations-common'
import { getAuthTypeWithExtension } from '../agave/auth/getAuthTypeWithExtension'
import { getForceSignInUrl, getMsaImplicitGrantSignInUrl } from '../shared/auth/getSignInUrl'

export function showSessionExpired(layoutSDK: LayoutSDK): void {
  const authType: AuthType | undefined = getAuthTypeWithExtension()
  layoutSDK.showSessionExpired(authType === 'msa_implicit' ? getMsaImplicitGrantSignInUrl() : getForceSignInUrl(false))
}
